module.exports = __webpack_public_path__ + "img/wallet-widget-background-1.e784662b.png";